import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import { FormattedMessage } from 'react-intl';
import Panel from 'components/Panel/Panel';
import Preloader from 'components/Preloader';
import NothingBox from 'components/NothingBox';
import DataTable from 'components/DataTable/DataTable';
import CustomColumn from 'components/DataTable/Columns/CustomColumn';
import FormattedTemperature from 'components/FormattedTemperature';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// styles
import './BarnsheetsTemperatureTable.scss';

class BarnsheetsTemperatureTable extends Component {
  state = {
    currentPage: 1,
    perPage: 10,
  };

  setCurrentPage = (currentPage) => this.setState({ currentPage });

  setPerPage = (perPage) => this.setState({ perPage, currentPage: 1 });

  renderDateColumn = ({ created_on }) => {
    const { countryCode } = this.props;

    return (
      <CustomColumn label={<FormattedMessage id="general.date" />}>
        <span>{formatDateForUser(created_on, countryCode)}</span>
      </CustomColumn>
    );
  };

  renderHighColumn = ({ high_temperature }) => (
    <CustomColumn label={<FormattedMessage id="general.high" />}>
      {high_temperature || high_temperature === 0 ? <FormattedTemperature value={high_temperature} /> : 'N/A'}
    </CustomColumn>
  );

  renderLowColumn = ({ low_temperature }) => (
    <CustomColumn label={<FormattedMessage id="general.low" />}>
      {low_temperature || low_temperature === 0 ? <FormattedTemperature value={low_temperature} /> : 'N/A'}
    </CustomColumn>
  );

  renderSetPointColumn = ({ set_point }) => (
    <CustomColumn label={<FormattedMessage id="general.setPoint" />}>
      {set_point || set_point === 0 ? <FormattedTemperature value={set_point} /> : 'N/A'}
    </CustomColumn>
  );

  paginateResources = (resources) => {
    const { perPage, currentPage } = this.state;
    return resources.slice((currentPage - 1) * perPage, currentPage * perPage);
  }

  render() {
    const { currentPage, perPage } = this.state;
    const { isLoading, data } = this.props;

    const columns = [
      { label: <FormattedMessage id="general.date" />, flex: '1 1 170px', renderer: this.renderDateColumn },
      { label: <FormattedMessage id="general.high" />, flex: '1 1 140px', renderer: this.renderHighColumn },
      { label: <FormattedMessage id="general.low" />, flex: '1 1 140px', renderer: this.renderLowColumn },
      { label: <FormattedMessage id="general.setPoint" />, flex: '1 1 140px', renderer: this.renderSetPointColumn },
    ];

    const paginationProps = {
      onPageChange: this.setCurrentPage,
      onPerPageChange: this.setPerPage,
      totalItems: data.length,
      currentPage,
      perPage,
    };

    const paginatedResources = this.paginateResources(data);

    return (
      <Panel className="BarnsheetsTemperatureTable">
        <Panel.Heading title={<FormattedMessage id="general.temperature" />} />
        <Panel.Body noPadding>
          <Preloader isActive={isLoading} />
          <DataTable
            data={paginatedResources}
            columns={columns}
            paginationProps={paginationProps}
            getRowClass={({ high_temperature, low_temperature }) => ({
              'pink': !high_temperature && !low_temperature,
            })}
            scrollable
            tableKey="barnsheetsTemperature"
          />
          <NothingBox
            display={!paginatedResources.length}
            isLoading={isLoading}
          >
            <h2 className="lighter"><FormattedMessage id="component.nothingBox.noData" /></h2>
          </NothingBox>
        </Panel.Body>
      </Panel>
    );
  }
}

BarnsheetsTemperatureTable.propTypes = {
  isLoading: T.bool.isRequired,
  data: T.array.isRequired,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    isLoading: state.dataTable.barnsheetsTemperature.isLoading,
    countryCode: getCurrentCountryCode(state),
  })
)(BarnsheetsTemperatureTable);
